import React, { PropsWithChildren } from 'react';
import { ChevronLeftIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import styles from './toolbar.module.scss';
interface ToolBarProps {
  title?: string;

  onBack?: () => void;
}

export const ToolBar: React.FC<PropsWithChildren<ToolBarProps>> = ({ title, onBack, children }) => (
  <Container>
    {(onBack || title) && (
      <Left>
        {onBack && (
          <IconButton
            icon={<ChevronLeftIcon color="var(--color-grayscale-anti-flash-white)" />}
            onClick={onBack}
          />
        )}

        {title && <h3>{title}</h3>}
      </Left>
    )}

    {children}
  </Container>
);

export const Container = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['container']} ${className}` : styles['container']}
    {...props}
  />
);

const Left = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['left']} ${className}` : styles['left']} {...props} />
);

export const Tools = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['tools']} ${className}` : styles['tools']} {...props} />
);
